import { render, staticRenderFns } from "./SlotsTotal.vue?vue&type=template&id=29ae8dc4&lang=pug&"
import script from "./SlotsTotal.vue?vue&type=script&lang=js&"
export * from "./SlotsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports